// the Hash Route has to start with #
export const redirectTo = (path: string) => `#${path}`;
